module.exports = __webpack_public_path__ + "img/index5.67f98ea0.png";